import { Class } from "core/Abacus.Utilities";
import Cookies from "js-cookie";

$(document).ready(function() {
  $(".content-close-block").each(function() {
    new ContentClose(this);
  });
});

let ContentCloseOptions = {};

class ContentClose extends Class {
  constructor(element, options) {
    super();
    this.element = $(element);
    this.data = $(this.element).data("contentClose");
    this.setOptions(ContentCloseOptions, options);
    this.showContentCloseBlock();
    this.setupEvent();
  }

  setupEvent() {
    var self = this;
    $(this.element)
      .find(".content-close-block-trigger")
      .on("click", function(evt) {
        if (self.data) {
          evt.preventDefault();
          self.writeCookie();
        }
      });
  }

  hideContentCloseBlock() {
    $(this.element)
      .removeClass("content-close-block-show")
      .addClass("content-close-block-hide")
      .attr("aria-hidden", true);
  }

  showContentCloseBlock() {
    if (this.data && !this.readCookie(this.data.messageId)) {
      $(this.element)
        .removeClass("content-close-block-hide")
        .addClass("content-close-block-show")
        .attr("aria-hidden", false);
    }
  }

  writeCookie() {
    const protocol = window.location.protocol == "https:" ? true : false;
    Cookies.set(this.data.messageId, true, {
      path: "/",
      domain: `.${document.location.host}`,
      expires: this.data.expires || 7,
      secure: protocol
    });
    this.hideContentCloseBlock();
  }

  readCookie(name) {
    return Cookies.get(name);
  }
}

export { ContentClose };



// WEBPACK FOOTER //
// ./Javascript/core/classes/contentclose/content.close.block.class.js